// extracted by mini-css-extract-plugin
export default {"imageWrapper":"oJ-z","twoColumnImage":"pJ-z"};